export default from './GoogleAuthButton';



// WEBPACK FOOTER //
// ./src/sharedComponents/GoogleAuthButton/index.js